import React, { useState } from 'react'
import { Spacing } from '../../../components/table/Table'
import { ILink } from '../../../types'
import { PATHS } from '../../../routes/Routes'
import PageHeader from '../../../components/pageHeader/PageHeader'
import TableViewType from '../../../components/tableViewType/TableViewType'
import ExportSchedulesFilters from './ExportSchedulesFilters'
import ExportSchedulesTable from './ExportSchedulesTable'

const ExportSchedules = () => {
  const [viewType, setViewType] = useState<Spacing>(Spacing.Default)
  const navLinks: ILink[] = [
    {
      label: 'Batch Activity',
      link: PATHS.BATCH_ACTIVITY,
    },
    {
      label: 'Export Schedules',
      link: PATHS.SCHEDULES_EXPORT,
    },
  ]
  return (
    <div className='page-container'>
      <div className='page-content'>
        <PageHeader header='Export Schedules' navLinks={navLinks}></PageHeader>
        <div className='table-filters'>
          <div className='filters-container'>
            <ExportSchedulesFilters />
          </div>
          <div className='table-view-type'>
            <TableViewType viewType={viewType} setViewType={setViewType} />
          </div>
        </div>
        <ExportSchedulesTable spacing={viewType} />
      </div>
    </div>
  )
}
export default ExportSchedules
